import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeLineBreaksString',
})
export class RemoveLineBreaksStringPipe implements PipeTransform {
    /**
     * Remove all line breaks from a string and transform it in a one line string
     * @param {string} value
     * @returns {string}
     */
    transform(value: string): string {
        return value.replace(/(\r\n|\n|\r)/gm, '. ').replace('..', '.');
    }
}
